import { AccordionIcon as ChakraAccordionIcon } from "@chakra-ui/react";

export const AccordionIcon = ChakraAccordionIcon;
